module.exports = __webpack_public_path__ + "img/c05_unittechennerischampion_Normal_ua.8bf2112f.webp";